import React, { Component } from 'react'
import JsonRender from './JsonRender'
import { StaticBox, FlowTable, NoContentBox } from 'components/basic'
import http from 'API/http'

class CustomTroubleshooting extends Component {
  constructor (props) {
    super(props)
    this.state = {
      troubleshooting: null,
      loading: true,
      error: false,
      unavailable: false
    }
  }

  async componentDidMount () {
    this.getTroubleshooting(this.props.id)
  }

  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true})
    this.getTroubleshooting(props.id)
  }

  async getTroubleshooting (id) {
    var [err, res] = await http.make('troubleshoot/custom/access', {rich: true, id: id}, 'get')
    if (res.status === 503) return this.setState({unavailable: true, loading: false})
    if (err) return this.setState({error: true, cause: res.cause, loading: false})
    this.setState({troubleshooting: res.data, loading: false})
  }

  reload () {
    this.setState({loading: true})
    this.getTroubleshooting(this.props.id)
  }

  render () {
    return (
      <StaticBox icon='heartbeat' dataLoading={this.state.loading} title='Troubleshooting' buttons={[{ icon: (this.state.loading ? 'fa-refresh fa-spin' : 'fa-refresh'), event: () => this.reload(), disabled: this.state.loading}]}>
        {this.state.unavailable &&
          <div className='content-wrapper flexbox-absolute-center'>
            <NoContentBox icon='exclamation-triangle' text='This service is unavailable' />
          </div>
        }
        <div className='col-md-12'>
          {this.state.error &&
            <pre className='no-overflow mt-10 no-padding'>
              <div className='error-wrapper'>
                <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching Troubleshooting {this.state.error.cause ? '- ' + this.state.error.cause : ''}</b></span>
              </div>
            </pre>
          }
          {!this.state.error && this.state.troubleshooting && <JsonRender data={this.state.troubleshooting} />}
        </div>
      </StaticBox>
    )
  }
}
export default CustomTroubleshooting



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/troubleshooting/CustomTroubleshooting.js